import { whiteLocaleList, productPageUrl } from 'elem/compPage/portable-power-station-calculator/config/pageConfig';
import SolarCalcPC from 'elem/compPage/portable-power-station-calculator/NewVersion';
import SolarCalcH5 from 'elem/compPage/portable-power-station-calculator/solar-panels';
import css from 'elem/compPage/portable-power-station-calculator/index.module.scss';
import PageLayout from '@/components/PageLayout';
import SupportBannerPc from '@/components/SupportCommon/SupportBanner';
import SupportBannerH5 from '@/componentsH5/SupportCommon/SupportBanner';
import Crum from '@/components/Crum';
import { redirectTo404 } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { ICalcSolarProps } from '@/components/calculators/solarpanels/OldVersion/cacl';
import SEOlinksA from '@/components/SEOlinksA';

export default function SolarPanelCalc({ SEO }: ICalcSolarProps) {
    const { isMobile, useLang, useRouter } = useGlobal();
    const { t } = useLang('calculatorssolarpanels');
    const { t: t1 } = useLang('shared');
    const router = useRouter();
    const { locale = 'us' } = router;
    const SupportBanner = isMobile ? SupportBannerH5 : SupportBannerPc;
    const Layout = isMobile ? SolarCalcH5 : SolarCalcPC;
    const bannerImgPath = isMobile
        ? 'https://websiteoss.ecoflow.com/upload/image/1749113516432/M.jpg'
        : 'https://websiteoss.ecoflow.com/upload/image/1749113516601/PC.jpg';

    const breadcrumbData = [
        { name: t1('crums.crum_home'), link: '/' },
        {
            name: t('calc_crum2_text'),
            link: `https://au.ecoflow.com/collections/portable-power-stations`,
        },
        { name: t('calc_crum3_text') },
    ];

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc') || ''} />
            <SEOlinksA locale={locale} list={whiteLocaleList} pathname={productPageUrl} />
            <PageLayout>
                <div className={css.calc_solarpanel}>
                    <SupportBanner
                        isSearch={false}
                        title={t('calc_page_title')}
                        subTitle={t('calc_page_subtitle')}
                        subTitleShow
                        isWebp
                        webpSrc={bannerImgPath}
                        bgImages={bannerImgPath}
                    />
                    {/* 面包屑 */}
                    <Crum data={breadcrumbData} />
                    {/* 计算器 */}
                    <Layout />
                </div>
            </PageLayout>
        </>
    );
}
export async function getServerSideProps({ locale }: any) {
    if (!whiteLocaleList.includes(locale)) {
        return redirectTo404();
    }

    return {
        props: {},
    };
}
